import { createContext, useContext } from "react";
import { AVAILABLE_LOCALES } from "~/core/locale";

type LocaleProviderContextType = {
  locale: AVAILABLE_LOCALES;
  onLocaleChange: (locale: AVAILABLE_LOCALES) => void;
};

const AppLocaleContext = createContext<LocaleProviderContextType>({
  locale: AVAILABLE_LOCALES.fr,
  onLocaleChange: () => {
    return;
  },
});

export const useLocale = () => {
  const context = useContext(AppLocaleContext);

  if (context === undefined) {
    throw new Error("useAppLocale must be used within a LocaleProvider");
  }

  return context;
};
